import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { fetchMessages } from 'store/commboard/actions'
import { fetchOrgGroups } from 'store/Group/actions'
import { fetchRoles } from 'store/Group/actions'

export function useMessages() {
  const commboard = useSelector((state) => state.commboard)
  const messages = useSelector((state) => state.commboard.messages)
  const user = useSelector((state) => state.auth.user)
  const dispatch = useDispatch()

  const { messagesFetched } = useSelector((state) => state.dashboard)

  useEffect(() => {
    if (messagesFetched) return
    dispatch(fetchMessages())
    dispatch(fetchRoles())
    dispatch(fetchOrgGroups())
  }, [messagesFetched])

  return { messages, user, commboard }
}
